import ReminderTasks from "./ReminderTasks";
import { useAuth } from "../context/AuthContext";

/**
 * Reminders is the single, unified surface for all semi-automatic
 * customer messaging + assigned employee tasks:
 *
 *   • Birthday wishes
 *   • Collection receipt messages (Loan / Saving Scheme)
 *   • Welcome messages for new Loan / Saving Scheme
 *   • Month-end summaries
 *   • Assigned employee tasks (admins assign; employees see only their own)
 *
 * Each row exposes Call / SMS / WhatsApp / Mark Done buttons.
 * Employees see only what has been assigned to them; admins see everything
 * inside their branch scope and can assign to any employee in that scope.
 */
export default function Reminders() {
    const { user } = useAuth();
    const isAdmin = user?.role === "admin" || user?.role === "super_admin";

    return (
        <div className="space-y-5" data-testid="reminders-page">
            <div>
                <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">
                    Reminders
                </h1>
                <p className="text-sm text-slate-500 mt-1">
                    {isAdmin
                        ? "Birthdays, collection receipts, welcome and month-end reminders — assign to an employee or send yourself via Call, SMS or WhatsApp."
                        : "Reminders assigned to you. Use Call, SMS or WhatsApp to reach the customer, then mark done."}
                </p>
            </div>

            <ReminderTasks embed />
        </div>
    );
}
